import DateInputClass from './date';
import ItemNumberInputClass from './item_number';

export const dateInput: DateInputClass = new DateInputClass();

export const itemNumber: ItemNumberInputClass = new ItemNumberInputClass();
